import { IAutomationObject } from "../../types";

export interface IControlledMax extends IAutomationObject {
    value1: number;
    value2: number;
    valueMax: number;
}


export const schema = 'AutomationApps.Logics.ControlledMax';


    